import Storage from "./storage";

let LC = new Storage( localStorage, 'local_storage_' );

export default LC;
